import { useEffect } from 'react';

import { routes } from '@aline/routes';
import { useMatch } from 'react-router-dom';
import { aiThreadIdVar } from 'src/editor';

/**
 * Syncs the singleton AI chat thread id with the /chat route. The full-page
 * chat renders through the maximized global drawer, so the chat page only
 * needs to publish the routed thread id (or null on the index route).
 */
export function useSyncAiThreadWithRoute() {
  const threadId = useMatch(routes.ChatDetail)?.params.threadId ?? null;

  useEffect(() => {
    aiThreadIdVar(threadId);
  }, [threadId]);
}
